import FiltersGenerator from "./FiltersGenerator";

export default FiltersGenerator;
